export const historyKeys = {
  all: () => ["bookingHistory"],
  ofBooking: (bookingId: number) => [...historyKeys.all(), bookingId]
};
